import { BoundingBox, Quat, Vec3 } from 'playcanvas';

import { Scene } from './scene';
import { Serializer } from './serializer';

enum ElementType {
    camera = 'camera',
    model = 'model',
    splat = 'splat',
    shadow = 'shadow',
    debug = 'debug',
    other = 'other'
}

const ElementTypeList = [
    ElementType.camera,
    ElementType.model,
    ElementType.splat,
    ElementType.shadow,
    ElementType.debug,
    ElementType.other
];

let nextUid = 1;

class Element {
    type: ElementType;
    scene: Scene = null;
    uid: number;
    numSelected: number = 0;

    constructor(type: ElementType) {
        this.type = type;
        this.uid = nextUid++;
    }

    set visible(value: boolean) {}

    get visible(): boolean {
        return true;
    }

    destroy() {
        if (this.scene) {
            this.scene.remove(this);
        }
    }

    add(): void | Promise<void> {}

    remove() {}

    serialize(serializer: Serializer) {}

    onUpdate(deltaTime: number) {}

    onPostUpdate() {}

    onPreRender() {}

    onPostRender() {}

    onAdded(element: Element) {}

    onRemoved(element: Element) {}

    move(position?: Vec3, rotation?: Quat, scale?: Vec3) {}

    get worldBound(): BoundingBox | null {
        return null;
    }

    docSerialize(): any {
        return null;
    }

    docDeserialize(_doc: any): void {}

    static setNextUid(uid: number) {
        nextUid = uid;
    }

    static getNextUid() {
        return nextUid;
    }
}

export { ElementType, ElementTypeList, Element };
